import type { EditorPlugin } from '../../../types/aha-editor';
import { concatenateStyle } from '../utils';
import ColorUtils from '../../../util/color';

const TextColorMarkPlugin: EditorPlugin = {
  name: 'TextColor mark plugin',
  mark: {
    type: 'textColor',
    use: ({ leaf, props }) => {
      const color = leaf.textColor
        ? ColorUtils.mapColorFromColorPickerToDarkMode(leaf.textColor)
        : undefined;

      return concatenateStyle({ ...props }, 'color', color);
    },
  },
};
export default TextColorMarkPlugin;
